import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Nav from '../components/Nav';
import Users from './users/Users';
import Vendors from './vendors/Vendors';
import Products from './products/Products';
import InventoryCheck from './inventory-check/InventoryCheck';
import CycleReview from './inventory-check/CycleReview';
import PhotoUpload from './photo-upload/PhotoUpload';
import PhotoReview from './photo-review/PhotoReview';
import FindPiece from './find-piece/FindPiece';
import ConfirmSales from './commissions/ConfirmSales';
import PayCommissions from './commissions/PayCommissions';
import CapitalPreset from './capital/CapitalPreset';
import Calendar from './calendar/Calendar';
import VendorPage from './calendar/VendorPage';
import CalendarBills from './calendar/admin/CalendarBills';
import BankAccounts from './calendar/admin/BankAccounts';
import NeedsAttention from './calendar/admin/NeedsAttention';
import useFetch from '../hooks/useFetch';
import { useEffect, useState } from 'react';

export default function Dashboard(props) {
    const { auth, setAuth } = props
    const [vendors, setVendors] = useState([]);
    const { fetchResource } = useFetch({ setAuth });

    useEffect(() => {
        async function fetchVendors() {            
            try {
                const response = await fetchResource({ method: 'GET', resource: 'vendors' });
                if (response.error) throw new Error(response.error);
                setVendors(response.vendors);
            } catch (error) {
                alert(`Error getting vendors list: ${error.message}`);
            }
        }
        fetchVendors();
    }, []);

    return (
        <Router>
            <Nav auth={auth} setAuth={setAuth} />
            <Routes>
                <Route path='/' element={<Products auth={auth} setAuth={setAuth} vendors={vendors}/>} />
                <Route exact path='/users' element={<Users auth={auth} setAuth={setAuth} />} />
                <Route exact path='/products' element={<Products auth={auth} setAuth={setAuth} vendors={vendors}/>} />
                <Route exact path='/find-piece' element={<FindPiece auth={auth} setAuth={setAuth} vendors={vendors} />} />
                <Route exact path='/vendors' element={<Vendors auth={auth} setAuth={setAuth} vendors={vendors} setVendors={setVendors} />} />
                <Route exact path='/inventory-check' element={<InventoryCheck auth={auth} setAuth={setAuth} />} />
                {/* Gated the same way its nav entry is. The server 401s an unpermitted
                    clerk, but this screen archives products off the live storefront -
                    it must not paint live-looking Finalizar / Descartar buttons at all. */}
                {auth?.perms?.INVCR && (
                    <Route exact path='/inventory-check/report' element={<CycleReview auth={auth} setAuth={setAuth} />} />
                )}
                <Route exact path='/photo-upload' element={<PhotoUpload auth={auth} setAuth={setAuth} />} />
                {/* Admin-only until a staff view exists (spec 2026-10-15). */}
                {auth?.perms?.PHOTOR && (
                    <Route path='/photo-review/*' element={<PhotoReview auth={auth} setAuth={setAuth} />} />
                )}
                <Route exact path='/confirm-sales' element={<ConfirmSales auth={auth} setAuth={setAuth} />} />
                <Route exact path='/pay-commissions' element={<PayCommissions auth={auth} setAuth={setAuth} />} />
                {auth?.perms?.ROOT && (
                    <Route exact path='/capital' element={<CapitalPreset auth={auth} setAuth={setAuth} />} />
                )}
                <Route exact path='/calendar' element={<Calendar auth={auth} setAuth={setAuth} />} />
                <Route exact path='/calendar-vendor/:id' element={<VendorPage auth={auth} setAuth={setAuth} />} />
                <Route exact path='/calendar-bills' element={<CalendarBills auth={auth} setAuth={setAuth} />} />
                <Route exact path='/calendar-accounts' element={<BankAccounts auth={auth} setAuth={setAuth} />} />
                <Route exact path='/calendar-attention' element={<NeedsAttention auth={auth} setAuth={setAuth} />} />
            </Routes>
        </Router>
    )
}
